import { render, staticRenderFns } from "./ProjectHrus.vue?vue&type=template&id=36d34138&"
import script from "./ProjectHrus.vue?vue&type=script&lang=js&"
export * from "./ProjectHrus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports